
var stache = require('can/view/stache/stache');
module.exports = stache("<live-video-player></live-video-player>");